import React from "react";
import tboy from "./images/tboy.JPG";
import music from "./images/music.png";
import car from "./images/car.png";
import hotel from "./images/hotelapp.png";
import Connect from "./Connect";
import pec from "./images/Capture.PNG";
import charis from "./images/charis@2.PNG";
function Projects() {
  return (
    <div>
      <div className="project">
        <h3
          style={{
            color: "white",
            position: "relative",
            left: "20px",
            overflow: "hidden",
            top: "30px",
          }}
          className="skill-text"
        >
          {" "}
          My Projects
        </h3>
        <div className="line"></div>

        <center>
          <div
            class="card"
            style={{ width: "20rem", position: "relative", top: "40px" }}
          >
            <div class="">
              <div
                className="card-header"
                style={{ fontWeight: "bolder", fontSize: "13px" }}
              >
                01. Sell Your Car App
              </div>
            </div>
            <img src={car} class="card-img-top" alt="..." />
            <div className="card-body">
              <p
                className="card-text"
                style={{ fontWeight: "bolder", fontSize: "13px" }}
              >
                A fully responsive website to display cars for sale.
              </p>
              <a
                href="https://cars-org.netlify.app/"
                class="btn btn-primary"
                style={{ fontWeight: "bolder", fontSize: "12px" }}
              >
                View Live Link
              </a>
            </div>
          </div>
          {/*  */}

          {/*  */}
          <br />
          <br />
          <div
            class="card"
            style={{ width: "20rem", position: "relative", top: "40px" }}
          >
            <div class="">
              <div
                className="card-header"
                style={{ fontWeight: "bolder", fontSize: "13px" }}
              >
                02. A Single Page Laundry Website.
              </div>
            </div>
            <img src={pec} class="card-img-top" alt="..." />
            <div className="card-body">
              <p
                className="card-text"
                style={{ fontWeight: "bolder", fontSize: "13px" }}
              >
                A fully responsive laundry website.
              </p>
              <a
                href="https://peculiar-laundry.netlify.app/"
                class="btn btn-primary"
                style={{ fontWeight: "bolder", fontSize: "12px" }}
              >
                View Live Link
              </a>
            </div>
          </div>
          {/*  */}
          {/*  */}
          <br />
          <br />
          <div
            class="card"
            style={{ width: "20rem", position: "relative", top: "40px" }}
          >
            <div class="">
              <div
                className="card-header"
                style={{ fontWeight: "bolder", fontSize: "13px" }}
              >
                03. A food Website for a client.
              </div>
            </div>
            <img src={charis} class="card-img-top" alt="..." />
            <div className="card-body">
              <p
                className="card-text"
                style={{ fontWeight: "bolder", fontSize: "13px" }}
              >
                A fully responsive website built for a client.
              </p>
              <a
                href="https://peculiar-laundry.netlify.app/"
                class="btn btn-primary"
                style={{ fontWeight: "bolder", fontSize: "12px" }}
              >
                View Live Link
              </a>
            </div>
          </div>
          {/*  */}

          <div
            class="card"
            style={{ width: "20rem", position: "relative", top: "80px" }}
          >
            <div class="">
              <div className="card-header" style={{ fontWeight: "bolder" }}>
                03. An Hotel Website
              </div>
            </div>
            <img src={hotel} class="card-img-top" alt="..." />
            <div className="card-body">
              <p className="card-text" style={{ fontWeight: "bolder" }}>
                A fully responsive hotel website.
              </p>
              <a
                href="https://glamours-hotel.netlify.app/"
                class="btn btn-primary"
                style={{ fontWeight: "bolder", fontSize: "12px" }}
              >
                View Live Link
              </a>
            </div>
          </div>
          {/*  */}
          {/*  */}
          <div
            class="card"
            style={{
              width: "20rem",
              position: "relative",
              top: "100px",
            }}
          >
            <div class="">
              <div className="card-header" style={{ fontWeight: "bolder" }}>
                03. Music App
              </div>
            </div>
            <img src={music} class="card-img-top" alt="..." />
            <div className="card-body">
              <p
                className="card-text"
                style={{
                  fontWeight: "bolder",
                  position: "relative",
                  bottom: "15px",
                }}
              >
                A Mini Music App
              </p>
              <a
                href="https://minimusicapp.netlify.app/"
                class="btn btn-primary"
                style={{
                  fontWeight: "bolder",
                  position: "relative",
                  bottom: "25px",
                  fontSize: "12px",
                }}
              >
                View Live Link
              </a>
            </div>
          </div>
        </center>
        <Connect />
      </div>
    </div>
  );
}

export default Projects;
